module.exports = __webpack_public_path__ + "img/36_39.a85763ad.png";